import { connect } from 'react-redux';
import InfoMap from './InfoMap';

const mapStateToProps = ({
  userReducer,
  pieceInfoReducer,
  infoMapReducer
}) => ({
  userReducer,
  pieceInfoReducer,
  infoMapReducer
});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InfoMap);
